<template>
    <nav class="panel is-info">
        <div v-if="user">

            <UserInfo :orderLoading="orderLoading" @setOrder="setOrder"
                      :order="order"
                      :user="user"
                      v-on:update:orderLoading="$emit('update:orderLoading', $event)"/>
        </div>
        <div v-else>
            <div class="panel-heading">
                <div class="field has-addons">
                    <p class="control has-icons-left is-expanded" :class="{'is-loading': usersLoading}">
                        <input class="input is-size-5-tablet is-size-6-desktop"
                               :value="searchQuery" v-on:keypress.enter="setUserName(searchQuery)"
                               @input="handleSearchQuery"

                               type="text" placeholder="Пребарувај">
                        <span class="icon is-size-5-tablet is-size-6-desktop is-left"><i class="fa fa-search"
                                                                                         aria-hidden="true"/></span>
                    </p>
                    <p class="control">
                        <button @click="tempSavePhone" class="button is-light"><span class="fa fa-phone"></span>
                        </button>
                    </p>
                </div>
            </div>
            <a v-if="searchQuery" class="panel-block" v-on:click.once="setUserName(searchQuery)">
                <div class="tags has-addons ">
                    <span class="tag is-medium is-size-4-tablet is-size-6-desktop">Креирај:</span>
                    <span class="tag is-medium is-primary is-size-4-tablet is-size-6-desktop">{{searchQuery}}</span>
                </div>
            </a>
            <div ref="suggestions" :style="reservedHeight ? {minHeight: reservedHeight + 'px'} : null">
                <SelectClientItem v-for="c in users" v-bind:key="c.id" :client="c" @setUserId="setUserId"/>
            </div>
        </div>
    </nav>

</template>

<script>
    import UserInfo from "./UserInfo";
    import SelectClientItem from "./SelectClientItem";

    export default {
        name: "NewOrderClient",
        props: ["user", "order", "orderLoading", "notFinishedOrder"],
        components: {SelectClientItem, UserInfo},
        data() {
            return {
                users: [],
                searchQuery: "",
                tempPhone: null,
                cancelUsers: null,
                timeoutUsers: null,
                usersLoading: false,
                // Tallest the suggestions have been during this search, held as a floor
                // under them — see reserveSuggestionsHeight.
                reservedHeight: null,
                // Which search the arriving results belong to; a cancelled one must not
                // switch the spinner off under the search that replaced it.
                searchToken: 0,
            }
        },
        methods: {
            handleSearchQuery(e){
                let sel = e.target.selectionStart;
                this.searchQuery = this.$l2c(this.$rbn(e.target.value))
                this.$nextTick(()=>{
                    e.target.selectionStart = e.target.selectionEnd = sel;
                })
            },
            tempSavePhone() {
                if (new RegExp(/^\+*[0-9]{9,12}$/).exec(this.searchQuery)) {
                    this.tempPhone = this.searchQuery;
                    this.searchQuery = "";
                    this.$toast({message: "Привремено зачуван телефонски број", type: 'is-success'});
                } else
                    this.$toast({message: "Не валиден телефонски број", type: 'is-danger'});

            },
            setUserName(event) {
                if (!new RegExp(/^[љњертѕуиопшѓасдфгхјклчќзџцвбнмжЉЊЕРТЅУИОПШЃЖАСДФГХЈКЛЧЌЗЏЦВБНМ. \-()]{2,}$/).exec(event)) {
                    this.$toast({message: "Не валидно име и презиме", type: 'is-danger'});
                    return;
                }
                this.$emit("update:orderLoading", true);
                let send = {name: event};
                if (this.tempPhone) Object.assign(send, {phone_number: this.tempPhone})
                this.$http.post("/orders/" + this.order.id + "/user", send)
                    .then(a => {
                        this.tempPhone = null;
                        this.setOrder(a.data.data)
                        this.$emit("update:orderLoading", false);

                    });
            },
            setUserId(event) {
                this.$emit("update:orderLoading", true);
                this.$http.patch("/orders/" + this.order.id + "/user/" + event)
                    .then(a => {
                        this.setOrder(a.data.data)
                        this.$emit("update:orderLoading", false);
                        //check if user has order with status submited or created
                        this.$emit("update:notFinishedOrder", !!a.data.data.not_finished)
                    });
            },
            // On a phone this panel is the last thing on the page, so it is under the
            // keyboard while the client is being searched. Every time it got shorter iOS
            // clamped the scroll, and it never scrolled back when the next result set made
            // it tall again — the page walked away under the finger on every keystroke.
            // So the suggestions never shrink while a search is going on: the previous
            // ones stay up (the spinner moved into the input) and the area keeps the
            // height of the tallest list it has shown. Cleared when the box is emptied.
            reserveSuggestionsHeight() {
                const el = this.$refs.suggestions;
                if (!el) return;
                this.reservedHeight = Math.max(this.reservedHeight || 0, el.offsetHeight);
            },
            searchUsers() {
                this.usersLoading = true;
                if (this.cancelUsers) this.cancelUsers.cancel();
                clearTimeout(this.timeoutUsers);
                const token = ++this.searchToken;
                this.timeoutUsers = setTimeout(() => {
                    this.cancelUsers = this.$http.CancelToken.source();
                    this.$http.get("/users?search=" + this.searchQuery+"&simple", {cancelToken: this.cancelUsers.token}).then(a => {
                        // A newer search is already running: it owns the spinner and the list.
                        if (token !== this.searchToken) return;
                        this.usersLoading = false;
                        // The api interceptor resolves with undefined on a handled error;
                        // keep the suggestions that are on screen.
                        if (!a) return;
                        // Measured while the outgoing list is still in the DOM.
                        this.reserveSuggestionsHeight();
                        this.users = a.data.data;
                    });
                }, 400);

            },
            setOrder(order) {
                this.$emit("setOrder", order);
            }
        },
        watch: {
            user: function () {
                // Attaching or detaching a client ends the search session — the next one
                // measures its own floor rather than inheriting a stale one.
                this.reservedHeight = null;
            },
            searchQuery: function (value) {
                // Emptying the box is a deliberate reset, and the default list that comes
                // back is the long one anyway, so the floor goes with it.
                if (!value) this.reservedHeight = null;
                this.searchUsers()
            }
        },
        created() {
            this.searchUsers();
        },

    }
</script>

<style>
</style>